"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.expectAngularRouteIsSet = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));
var _useCorrespondingAngularRoute = require("../../../hooks/useCorrespondingAngularRoute/useCorrespondingAngularRoute");
var expectAngularRouteIsSet = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(renderRoute, route) {
    var spy, calls, lastEvent;
    return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            spy = jest.spyOn(document, 'dispatchEvent');
            _context.next = 3;
            return renderRoute();
          case 3:
            calls = spy.mock.calls;
            lastEvent = calls[calls.length - 1][0];
            expect(lastEvent.type).toBe(_useCorrespondingAngularRoute.CHANGE_CORRESPONDING_ROUTE_EVENT);
            expect(lastEvent.detail).toBe(route);
          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function expectAngularRouteIsSet(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
exports.expectAngularRouteIsSet = expectAngularRouteIsSet;